import {createTheme, ThemeOptions} from '@mui/material'
import baseUnit from './base_unit'
import defaultTheme from './default_theme'

const createCustomTheme = (customTheme: Partial<ThemeOptions> | null) => {
  const options = customTheme
    ? ({...baseUnit, ...customTheme} as ThemeOptions)
    : ({...baseUnit, ...defaultTheme} as ThemeOptions)
  return createTheme(options)
}

export default createCustomTheme
